import React from "react";
import { setActiveMenuItem } from "../../../actions/menu";
import AbstractEntitiesGrid from "./entitiesGrid";
import AbstractEntityForm from "./entityForm";
import AbstractRevisionGrid from "./revisionsGrid";
import Secure, {secureScreen} from "../../components/secure";
import PERMISSIONS from "../../../model/permissions";

class WrappedEntitiesGrid extends AbstractEntitiesGrid {
    componentDidMount() {
        super.componentDidMount();
        setActiveMenuItem({id: this.getEntity()})
    }
}

class WrappedEntityForm extends AbstractEntityForm {
    componentDidMount() {
        super.componentDidMount();
        setActiveMenuItem({id: this.getEntity()})
    }
}

class WrappedRevisionGrid extends AbstractRevisionGrid {
    componentDidMount() {
        super.componentDidMount();
        setActiveMenuItem({id: this.getEntity()})
    }
}

export const EntitiesGrid = secureScreen(WrappedEntitiesGrid, [PERMISSIONS.ADMIN_SUPERUSER]);
export const EntityForm = secureScreen(WrappedEntityForm, [PERMISSIONS.ADMIN_SUPERUSER]);
export const RevisionGrid = secureScreen(WrappedRevisionGrid, [PERMISSIONS.ADMIN_SUPERUSER]);